import coinIcon from '../assets/coin-icon.png'

interface LastMonthRevenueCardProps {
  displayAmount: string
  monthName: string
}

export function LastMonthRevenueCard({
  displayAmount,
  monthName,
}: LastMonthRevenueCardProps) {
  return (
    <div
      className='mt-[16px] flex w-full items-center justify-between rounded-[28px] bg-white p-[20px] shadow-[0px_5px_10px_rgba(110,89,205,0.25)]'
      data-testid='last-month-revenue-card'
    >
      <p className='font-semibold text-[14px] leading-normal text-[rgba(0,0,0,0.7)] not-italic'>
        {monthName} Revenue
      </p>
      <div className='flex items-center gap-[4px]'>
        <img alt='' className='size-[16px]' src={coinIcon} />
        <p className='font-semibold text-[14px] leading-normal text-black not-italic text-center'>
          {displayAmount}
        </p>
      </div>
    </div>
  )
}
